import React from "react";
import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { setSelectedPatientPosition } from "state/slices/SceneSlice";
import { builder, loader } from "Classes/global";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { openDialog } from "state/slices/DialogSlice";

import lateral_left from "assets/images/preset/male/lateral-left.png";
import lateral_right from "assets/images/preset/male/lateral-right.png";
import legs_lowered from "assets/images/preset/male/legs-lowered.png";
import legs_raised from "assets/images/preset/male/legs-raised.png";
import split_legs from "assets/images/preset/male/split-leg.png";
import supine from "assets/images/preset/male/supine.png";

import lateral_left_c from "assets/images/preset/child/lateral-left.png";
import lateral_right_c from "assets/images/preset/child/lateral-right.png";
import supine_c from "assets/images/preset/child/supine.png";

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
const PatientPositionItem = ({ item }: any): JSX.Element => {
    const dispatch = useTypedDispatch();
    const type = useTypedSelector((store) => store.Dialog.type);

    const handleLoad = (): void => {
        dispatch(setSelectedPatientPosition(item.name));

        if (loader.assetsloaded) {
            builder.room.updatePatientPosition(item.name);
        } else {
            builder.room.currentConfiguration.patientPosition.name = item.name;
        }

        dispatch(openDialog({ isDialogOpen: false, type }));
    };

    const renderImage = (): string => {
        let image: string;
        switch (item.name) {
            case "UpperGI set up Male":
                image = supine;
                break;
            case "Pelvic Set Up Male":
                image = legs_raised;
                break;
            case "Lateral Left Armless Male":
                image = lateral_left;
                break;
            case "Lateral Right Armless Male":
                image = lateral_right;
                break;
            case "Split Leg Position Male":
                image = split_legs;
                break;
            case "Modified Lloyds Davies Male":
                image = legs_lowered;
                break;
            case "UpperGI set up Child":
                image = supine_c;
                break;
            case "Lateral Left Armless Child":
                image = lateral_left_c;
                break;
            case "Lateral Right Armless Child":
                image = lateral_right_c;
                break;
        }
        return image;
    };

    return (
        <Grid item sm={12}>
            <Card className="patientCard" onClick={handleLoad} style={{ cursor: "pointer" }}>
                <CardMedia component="img" height="300" image={renderImage()} alt="patient item" />
                <CardContent className="cardContent">
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item xs={12}>
                            <Button startIcon={<ArrowForwardIosIcon className="iconArrow" />}>
                                {item.label || item.name}
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default PatientPositionItem;
